import { ToastTheme } from '../types';

export enum ToastTypes {
  DEFAULT = 'DEFAULT',
  LIGHT_POPOVER = 'LIGHT_POPOVER',
}

export interface State {
  /** A queue of toasts to display */
  queue: ToastConfiguration[];

  /** Add a single toast to the queue */
  initToast: (config: ToastConfiguration) => void;
  /** Add an array of toasts to the queue */
  initToastBatch: (config: ToastConfiguration[]) => void;
  /** Display a toast */
  fire: (
    config: Partial<ToastConfiguration> | Partial<ToastConfiguration>[]
  ) => void;
}

/** Configuration for a single Toast */
export interface ToastConfiguration {
  /** A unique ID for the toast */
  id: string;
  /** Type of toast for get different view and position */
  type: ToastTypes;
  /** The actual text message inside a toast */
  label: string;
  /** The amount of time a toast is visible, in ms, without animation duration. */
  duration: number;
  /** The amount of time to pass before a toast is displayed, in ms */
  delay: number;
  /** Whether it's an error message */
  error: boolean;
  /** Shorthand config option to display a toast that is more compact */
  small: boolean;
  /** The theme for the toast to display */
  theme: ToastTheme;
}

// ID can't be part of the defaults because by definition it has be to unique.
export type DefaultConfiguration = Omit<ToastConfiguration, 'id'>;
